import FullQuote from 'common/FullQuote';
import { ChannelEnum } from 'graphql/types';
import React from 'react';

import { Minimal } from '../src/layouts';
import WithLayout from '../src/WithLayout';

const QuotePageKarryCar = (): JSX.Element => {
  return (
    <WithLayout
      layout={Minimal}
      component={FullQuote}
      channel={ChannelEnum.Karrycar}
      pageTitle={'Motohelp – Preventivo KarryCar'}
    />
  );
};

export default QuotePageKarryCar;
